// client\helper\Private.js
const Private = {
  // 列表根据用户数据权限获取
  // 查询品牌列表
  brandHeadList: [
    // { id: 'CCW001', name: 'WEY' },
    // { id: 'CCH001', name: '哈弗' },
    // { id: 'CCO001', name: '欧拉' },
    // { id: 'CCP001', name: '长城皮卡' },
    // { id: 'CCZ001,CCW001,CCH001,CCO001,CCP001', name: '综合' },
  ],
  // 查询企业列表
  enterpriseHeadList: [
    // { id: 'XDZN,CC01', name: '全部' },
    // { id: 'XDZN', name: '仙豆' },
    // { id: 'CC01', name: '长城' },
  ],
  // 新增等品牌列表 // 始终为一条数据
  brandUserList: [
    // { id: 'CCZ001', name: '综合' },
  ],
  // 新增等企业列表 // 始终为一条数据
  enterpriseUserList: [
    // { id: 'XDZN', name: '仙豆' },
  ],
  // 用户所属品牌
  userBrandId: sessionStorage.getItem('PRIVATE_USER_BRANDID'),
  // 用户所属企业
  userEnterpriseId: sessionStorage.getItem('PRIVATE_USER_ENTERPRISEID'),
  // 查询企业及品牌默认字段 // 固定值
  // sessionStorage.getItem('PRIVATE_SEARCH_BRANDID'); // 暂存
  // sessionStorage.getItem('PRIVATE_SEARCH_ENTERPRISEID'); // 暂存
  // 新增企业及品牌默认字段 // 固定值
  // sessionStorage.getItem('PRIVATE_USER_BRANDID'); // 暂存
  // sessionStorage.getItem('PRIVATE_USER_ENTERPRISEID'); // 暂存
};
export default Private;

  // <div>
  //   <div class="ne-search">
  //     <div class="search-item">
  //       <label>企业：</label>
  //       <Select v-model="searchData.enterpriseId" style="width: 200px;" placeholder="请选择">
  //         <Option v-for="(item, index) in $Private.enterpriseHeadList" :value="item.id" :key="index">{{item.name}}</Option>
  //       </Select>
  //     </div>
  //     <div class="search-item">
  //       <label>品牌授权：</label>
  //       <Select v-model="searchData.brandId" style="width: 200px;" placeholder="请选择">
  //         <Option v-for="(item, index) in $Private.brandHeadList" :value="item.id" :key="index">{{item.name}}</Option>
  //       </Select>
  //     </div>
  //     <div class="search-item">
  //       <Button type="primary" @click="getDataList('search')">查 询</Button>
  //       <Button @click="clearSearch">重 置</Button>
  //     </div>
  //     <div class="right">
  //       <Button type="primary" v-if="permission[ '/platform/shop/add' ]" icon="md-add" @click="add">添 加</Button>
  //     </div>
  //   </div>
  //   <Table border :columns="dataList_table_column" :data="dataList" :loading="loading.table"></Table>
  //   <Page transfer :total="dataListTotalCount" show-sizer show-elevator show-total
  //         :current="searchParams.pageIndex" :page-size="searchParams.pageSize"
  //         @on-change="getDataList" @on-page-size-change="pageSizeChange"></Page>
  //   <Modal v-model="modalShow" :mask-closable="false" :title="modalTitle" @on-cancel="modalShow = false">
  //     <div>
  //       <Form ref="formVali" :model="modalParams" :rules="ruleValidate" label-position="right"
  //             :label-width="120">
  //         <FormItem label="企业：" prop="enterpriseId">
  //           <Select :label-in-value="true" v-model="modalParams.enterpriseId" style="width: 200px;" placeholder="请选择">
  //             <Option v-for="(item, index) in $Private.enterpriseUserList" :value="item.id" :key="index">{{item.name}}</Option>
  //           </Select>
  //         </FormItem>
  //         <FormItem label="品牌授权：" prop="brandId">
  //           <Select :label-in-value="true" v-model="modalParams.brandId" style="width: 200px;" placeholder="请选择">
  //             <Option v-for="(item, index) in $Private.brandHeadList" :value="item.id" :key="index">{{item.name}}</Option>
  //           </Select>
  //         </FormItem>
  //       </Form>
  //     </div>
  //   </Modal>
  // </div>
  // <script>
  //   import { mapGetters } from 'vuex';
  //   export default {
  //     data() {
  //       return {
  //         searchData:{
  //           enterpriseId: sessionStorage.getItem('PRIVATE_SEARCH_ENTERPRISEID'),
  //           brandId: sessionStorage.getItem('PRIVATE_SEARCH_BRANDID'),
  //           pageIndex: 1,
  //           pageSize: 10,
  //         },
  //         modalParams: {
  //           brandId: sessionStorage.getItem('PRIVATE_USER_BRANDID'),
  //           enterprise: sessionStorage.getItem('PRIVATE_USER_ENTERPRISEID'),
  //         },
  //       };
  //     },
  //       clearSearch() {
  //         Object.assign(this.$data.searchData, this.$options.data().searchData);
  //       },


